export const SCROLL_DEBOUNCE = 100; // ms seconds
